module.exports = __webpack_public_path__ + "static/media/iconcoachingcall-copy-grey.31da0ca1.svg";